module.exports = __webpack_public_path__ + "img/mynavi.6e4a7656.png";